<div role="note" [class]="cardClasses">
  <span class="flex-item">
    <mat-icon style="color: inherit">{{ iconName }}</mat-icon>
  </span>
  <span class="flex-item">
    <ng-content />
  </span>
</div>
